(function($) {

    $(document).on('gp_ajax_done', init_reviews)

    let sidebar_rating;

    function init_reviews() {
        $(".account__review__item-star")
            // Show correct amount of stars when hovering over them
            .on("mouseenter", function () {
                let current_rating = $(this).attr("data-rating")
                if (current_rating){
                    $(this).attr("fill", "#EBB845") // fill the currently hovered star

                    $(this).siblings().each(function () {
                        if ($(this).attr("data-rating") <= current_rating) {
                            $(this).attr("fill", "#EBB845") // fill all previous stars
                        } else {
                            $(this).attr("fill", "#C6BDB0") // empty all following stars
                        }
                    })
                }
            })


        $(".sidebar__review_stars .account__review__item-star")
            .on("mouseenter", function () {
                sidebar_rating = $(this).attr("data-rating")
            })

        $(".account__review__item-stars .account__review__item-star")
            // Empty stars when hovering outside
            .on("mouseleave", function () {
                // empty all stars on mouse out
                $(this).attr("fill", "#C6BDB0")

                $(this).siblings().each(function () {
                    $(this).attr("fill", "#C6BDB0")
                })
            })
            // Rating click handler
            .on("click", function () {
                sidebar_rating = $(this).attr("data-rating")
                // Save the rating into the database
                const ajax_url = $(this).parent().attr("data-action")
                const context = $(this).attr("data-modal-context")
                if (ajax_url){
                    gp_ajax({
                        url: ajax_url,
                        type: "post",
                        dataType: "json",
                        data: {
                            "context": context
                        }
                    })
                }
            })

        // Order review submit handler
        $("button.sidebar__review_form-btn.btn__primary[data-order-id]").on("click", function (e) {
            e.preventDefault()

            // Save the rating into the database
            if ($(this).hasClass("processing")){
                return
            }
            $(this).addClass("processing")

            const ajax_url = $(this).attr("data-action")
            const order_id = $(this).attr("data-order-id")
            let review = $(this).prev("div.form__input").find("textarea").val()
            if (!review){
                review = ""
            }

            if (order_id && sidebar_rating && ajax_url){
                gp_ajax({
                    url: ajax_url,
                    type: "post",
                    data: {
                        "order_id": order_id,
                        "rating": sidebar_rating,
                        "review": review,
                    }
                })
                    .done(() => {
                        $(this).removeClass("processing")
                    })
            }
        })
        // Order review delete handler
        $("button.sidebar__review_form-clear.btn__secondary[data-order-id]").on("click", function (e) {
            e.preventDefault()

            if ($(this).hasClass("processing")){
                return
            }
            $(this).addClass("processing")

            if (!confirm(scripts_translations.my_account.review.confirm_delete)){
                $(this).removeClass("processing")
                return
            }

            const ajax_url = $(this).attr("data-action")
            const order_id = $(this).attr("data-order-id")
            if (order_id && ajax_url){
                gp_ajax({
                    url: ajax_url,
                    type: "post",
                    data: {
                        "order_id": order_id
                    }
                })
                    .done(() => {
                        $(this).removeClass("processing")
                    })
            }
        })

        // Product variant review submit handler
        $("button.sidebar__review_form-btn.btn__primary[data-product-variant-id]").on("click", function (e) {
            e.preventDefault()

            // Save the rating into the database
            if ($(this).hasClass("processing")){
                return
            }
            $(this).addClass("processing")

            if (!sidebar_rating){
                alert(scripts_translations.my_account.review.missing_rating)
                return
            }

            const ajax_url = $(this).attr("data-action")
            const order_item_id = $(this).attr("data-order-item-id")
            const product_variant_id = $(this).attr("data-product-variant-id")
            let review = $(this).prev("div.form__input").find("textarea").val()
            if (!review){
                review = ""
            }
            let replace_fragment = $(this).attr("data-replace-fragment")
            if (!replace_fragment){
                replace_fragment = ""
            }

            if (order_item_id && product_variant_id && sidebar_rating && ajax_url){
                gp_ajax({
                    url: ajax_url,
                    type: "post",
                    data: {
                        "order_item_id": order_item_id,
                        "product_variant_id": product_variant_id,
                        "rating": sidebar_rating,
                        "review": review,
                        "replace_fragment": replace_fragment,
                    }
                })
                    .done(() => {
                        $(this).removeClass("processing")
                    })
            }
        })
        // Product variant review delete handler
        $("button.sidebar__review_form-clear.btn__secondary[data-product-variant-id]").on("click", function (e) {
            e.preventDefault()

            if ($(this).hasClass("processing")){
                return
            }
            $(this).addClass("processing")

            if (!confirm(scripts_translations.my_account.review.confirm_delete)){
                $(this).removeClass("processing")
                return
            }

            const ajax_url = $(this).attr("data-action")
            const order_item_id = $(this).attr("data-order-item-id")
            const product_variant_id = $(this).attr("data-product-variant-id")
            let replace_fragment = $(this).attr("data-replace-fragment")
            if (!replace_fragment){
                replace_fragment = ""
            }
            if (order_item_id && product_variant_id && ajax_url){
                gp_ajax({
                    url: ajax_url,
                    type: "post",
                    data: {
                        "order_item_id": order_item_id,
                        "product_variant_id": product_variant_id,
                        "replace_fragment": replace_fragment,
                    }
                })
                    .done(() => {
                        $(this).removeClass("processing")
                    })
            }
        })

        // Save rating when a review modal is opened to be able to send it to AJAXes
        $('button.btn[data-open-modal="review-order"], button.btn[data-open-modal="review"]').on("click", function (e) {
            sidebar_rating = $(this).attr("data-rating")
        })

        // Scroll to the correct elements for reading reviews on desktop and mobile
        $("a.product__reviews-more-link").on("click", function (){
            if (window.screen.width > 767){
                $('html, body').animate({
                    scrollTop: $('.product__reviews-desktop').offset().top - 10
                }, 1000);
            }
            else {
                $('html, body').animate({
                    scrollTop: $('.product__reviews-mobile').offset().top - 10
                }, 1000);
            }
        })
    }

    init_reviews()

})(jQuery);